import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import { LifeBuoy, Mail, Clock, ArrowRight, ScrollText, FileText, Receipt } from "lucide-react";
import useReveal from "../../common/useReveal";
import "./contactSupport.css";

const CONTACT_EMAIL = "hola@reservasinfila.com";

const toTop = () => window.scrollTo({ top: 0 });

const ContactSupport = () => {
	const { language } = useContext(CombinedContext);
	const rootRef = useReveal();

	const t = translations[language].contact;
	const links = translations[language].footer.links;

	const legalLinks = [
		{ to: "/terms", label: links.terms, Icon: ScrollText },
		{ to: "/privacy", label: links.privacy, Icon: FileText },
		{ to: "/refund", label: links.refundPolicy, Icon: Receipt },
	];

	return (
		<div className="sf-ct-root" ref={rootRef}>

			{/* ── HEADER ── */}
			<header className="sf-ct-hero">
				<div className="sf-ct-hero-grid" aria-hidden="true"></div>

				<div className="sf-ct-hero-inner">
					<span className="sf-ct-eyebrow">{t.eyebrow}</span>
					<h1>{t.title}</h1>
					<p className="sf-ct-tagline">{t.tagline}</p>
				</div>
			</header>

			<div className="sf-ct-page">

				{/* ── EMAIL CARD ── */}
				<section className="sf-ct-primary" data-reveal>
					<div className="sf-ct-primary-icon">
						<Mail size={24} strokeWidth={1.8} />
					</div>

					<div className="sf-ct-primary-copy">
						<h2>{t.email.title}</h2>
						<p>{t.email.text}</p>
						<a href={`mailto:${CONTACT_EMAIL}`} className="sf-ct-email">
							{CONTACT_EMAIL}
						</a>
					</div>

					{/* <a href={`mailto:${CONTACT_EMAIL}`} className="sf-ct-btn">
						{t.emailCta}
						<ArrowRight size={16} className="sf-ct-btn-arrow" />
					</a> */}
				</section>

				{/* ── SUPPORT + RESPONSE ── */}
				<div className="sf-ct-grid">
					<article className="sf-ct-card" data-reveal>
						<div className="sf-ct-card-icon">
							<LifeBuoy size={20} strokeWidth={1.9} />
						</div>
						<h3>{t.support.title}</h3>
						<p>{t.support.text}</p>
					</article>

					<article className="sf-ct-card" data-reveal>
						<div className="sf-ct-card-icon">
							<Clock size={20} strokeWidth={1.9} />
						</div>
						<h3>{t.response.title}</h3>
						<p>{t.response.text}</p>
					</article>
				</div>

				{/* ── LEGAL SHORTCUTS ── */}
				<section className="sf-ct-legal" data-reveal>
					<div className="sf-ct-legal-copy">
						<h2>{t.legal.heading}</h2>
						<p>{t.legal.text}</p>
					</div>

					<ul className="sf-ct-legal-links">
						{legalLinks.map(({ to, label, Icon }) => (
							<li key={to}>
								<Link to={to} onClick={toTop}>
									<Icon size={17} strokeWidth={1.9} />
									{label}
									<ArrowRight size={15} className="sf-ct-legal-arrow" />
								</Link>
							</li>
						))}
					</ul>
				</section>

			</div>
		</div>
	);
};

export default ContactSupport;
